// src/utils/searchRoutes.js
import tools from '../data/tools';

export const searchRoutes = tools.flatMap(tool => {
  const mainRoute = {
    path: `/tools/${tool.category}/${tool.slug}`,
    name: tool.name,
    description: tool.description
  };

  const subRoutes = (tool.subTools || []).map(subTool => ({
    path: subTool.path,
    name: `${tool.name}: ${subTool.name}`,
    description: tool.description
  }));

  return [mainRoute, ...subRoutes];
});

searchRoutes.push({
  path: '*',
  name: 'Не найдено',
  description: 'Страница не найдена'
});